export const getDownloadVideUrl = (str: string): string => {
  const [id, name] = str.split("/").slice(-2);
  if (id && name) {
    return `${id}/${name}`;
  }
  return "";
};
